import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18N, I18NContext, GlobalContext } from 'commons';
import * as signupConstants from 'constants/signUp';
import './SignUpProgressGraph.scss';
import { selectShouldShowIncidentSub } from 'state/selectors/subscriptionSelectors';
import * as subscriptionActions from 'state/actions/subscriptionActions';

const SIGNUP_PROFILE = (
  {
    showAddress,
    showCustomfield,
    showAlertSubscription,
    showGroupSubscription,
    shouldIncidentSubShow
  }
) => {
  const result = [];
  result.push(signupConstants.SIGN_UP_SECTIONS.profile);
  if (showAddress) {
    result.push(signupConstants.SIGN_UP_SECTIONS.locations);
  }
  if (showAlertSubscription || showGroupSubscription || shouldIncidentSubShow) {
    result.push(signupConstants.SIGN_UP_SECTIONS.subscriptions);
  }
  if (showCustomfield) {
    result.push(signupConstants.SIGN_UP_SECTIONS.information);
  }
  result.push(signupConstants.SIGN_UP_SECTIONS.review);
  return result;
};

const getSectionIndex = currentSection => section => currentSection.id === section.id;

const getIconClass = (isCurrentSection, isPreviousSection) => {
  if (isCurrentSection) {
    return 'SignUpProgressGraph__icon--current';
  }
  if (isPreviousSection) {
    return 'SignUpProgressGraph__icon--previous';
  }

  return '';
};

const SignUpProgressGraph = ({
  currentSection,
  checkShowIncidentSub,
  shouldIncidentSubShow
}) => {
  const {
    account: { id: contactId, CSRF_TOKEN_FOR_SESSION: csrfToken = '' },
    organization: { showAddress, showCustomfield, showAlertSubscription, showGroupSubscription, showIncidentSub },
  } = useContext(GlobalContext);
  const i18n = useContext(I18NContext);
  useEffect(() => {
    checkShowIncidentSub({
      contactId,
      csrfToken,
      showAlertSubscription,
      showGroupSubscription,
      showIncidentSub });
  }, []);

  const singupProfile = SIGNUP_PROFILE(
    {
      showAddress,
      showCustomfield,
      showAlertSubscription,
      showGroupSubscription,
      shouldIncidentSubShow
    }
  );
  const currentSectionIndex = singupProfile.findIndex(section => section.id === currentSection);

  return (
    <div className="SignUpProgressGraph" tabIndex="-1" aria-hidden="true">
      {singupProfile.map((section, index) => {
        const isLastElement = singupProfile.length === index + 1;
        const isCurrentSection = currentSection === section.id;
        const sectionIndex = singupProfile.findIndex(getSectionIndex(section));
        const isPreviousSection = sectionIndex < currentSectionIndex;
        const currentSectionClass =
            isCurrentSection ? 'SignUpProgressGraph__section--selected' : '';
        const previousSectionClass =
            isPreviousSection ? 'SignUpProgressGraph__section--visited' : '';
        const previousSectionDividerClass = isPreviousSection
          ? 'SignUpProgressGraph__divider--selected'
          : '';
        const iconClass = getIconClass(isCurrentSection, isPreviousSection);
        const iconAriaLabel = `sign.up.step.${(isCurrentSection && 'current') || (isPreviousSection && 'completed') || 'not.completed'}`;

        return (
          <div className={`SignUpProgressGraph__section ${currentSectionClass || previousSectionClass}`} key={section.id}>
            <div className="SignUpProgressGraph__icon-container">
              <i className={`fas fa-check SignUpProgressGraph__icon ${iconClass}`} aria-label={i18n.get(iconAriaLabel, i18n.get(section.title))} />
              {!isLastElement && (
                <div className={`SignUpProgressGraph__divider ${previousSectionDividerClass}`} />
              )}
            </div>
            <I18N tag="span">{section.title}</I18N>
          </div>
        );
      })}
    </div>
  );
};

SignUpProgressGraph.propTypes = {
  currentSection: PropTypes.string,
  checkShowIncidentSub: PropTypes.func.isRequired,
  shouldIncidentSubShow: PropTypes.bool.isRequired,
};

SignUpProgressGraph.defaultProps = {
  currentSection: signupConstants.SIGN_UP_SECTIONS.profile.id,
};

const mapDispatchToProps = dispatch => ({
  checkShowIncidentSub: data => dispatch(subscriptionActions.checkShowIncidentSub.action(data))
});

const mapStateToProps = state => ({
  shouldIncidentSubShow: selectShouldShowIncidentSub(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignUpProgressGraph);
